// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"bead6c13","703":"550c3fac","787":"4ef63cfd"}[chunkId] + ".chunk.js";
};